// Of een meeteenheid uit de meetstandaard het ding zelf telt ('per lamp',
// 'per stuk', 'per woning') in plaats van het te meten ('strekkende meter',
// 'm2 folie').
//
// EEN PLEK VOOR TWEE AFNEMERS. Het scherm (materialFactorQuestion) stelt bij
// zo'n eenheid geen omrekenvraag en zegt dat het materiaal meetelt; de
// berekening (resolveMaterialIntervention) telt het dan als één. Stonden die
// twee los, dan kon het scherm 'telt mee' zeggen terwijl de berekening het
// materiaal stil wegliet — en dat gebeurde tot 2026-11-04 bij elke eigen
// LED-lamp. AI-CONTEXT: See docs/pitfalls.md#ui-shared-affordance-gated-per-caller
//
// AI-CONTEXT: See docs/features/materials-co2-circulariteit.md

// Vergeleken na het weghalen van een voorloop-'per ', zoals de standaard de
// meeste formuleert ('per lamp', 'per kraan', 'per woning').
const ITEM_COUNT_UNITS = new Set([
    'stuk', 'stuks', 'paar', 'lamp', 'lampen', 'kraan', 'kranen',
    'bewoner', 'bewoners', 'persoon', 'personen', 'woning', 'woningen',
    'huishouden', 'huishoudens',
])

/**
 * @param {string} unit - Meeteenheid zoals de standaard hem noemt
 * @returns {boolean}
 */
const isItemCountUnit = (unit) => {
    const value = (unit || '').trim().toLowerCase().replace(/^per\s+/, '')
    return value === '' || ITEM_COUNT_UNITS.has(value)
}

export default isItemCountUnit
